module.exports = __webpack_public_path__ + "img/digital-chart.4ad539bf.png";